export default __webpack_public_path__ + "media/images/banner-340x500-b7de221fe7e84d5cc08de7c1e68c0fd8.jpg";